import React, {useState} from "react";
import { useIntl, FormattedMessage } from "react-intl";
import ErrorBoundary from "../../ErrorBoundary";
import AddProductDialog from "./AddProductDialog";
import ProductsTable from "./ProductsTable";
import { UserPlusIcon } from "@heroicons/react/24/solid";
import { PageHeading } from "../../Container";
import Button from "../../Button";
import {useProducts} from "@feature/products/hooks/useProducts";
import {useRoles} from "@feature/roles/hooks/useRoles";

function Products() {

  // hooks
  const intl = useIntl();
  const {fetch, add, update, loading} = useProducts();
  const {data: roles} = useRoles();

  // state
  const [showNewProductDialog, setShowNewProductDialog] = useState(false);
  const [refreshObservable, setRefreshObservable] = useState(false);

  // utilities
  const refreshTable = () => setRefreshObservable((prev) => !prev);

  return <>
    <PageHeading
      title={intl.formatMessage({ id: "products" })}
      contentActions={
        <Button
          variant="contained"
          color="primary"
          onClick={() => { setShowNewProductDialog(true); }}
        >
          <UserPlusIcon
            className="-ml-0.5 mr-2 h-4 w-4"
            aria-hidden="true"
          />
          <FormattedMessage id="add" />
        </Button>
      }
    />
    <ErrorBoundary from="products-table">
      <ProductsTable
        {...{fetch, update, loading}}
        refreshObservable={refreshObservable}
      />
    </ErrorBoundary>
    {showNewProductDialog && (
      <ErrorBoundary from="products-add-dialog">
        <AddProductDialog
          roles={roles}
          onConfirm={async (data) => {
            const result = await add(data);
            if (!!result) {
              refreshTable();
              setShowNewProductDialog(false);
            }
          }}
          onClose={() => setShowNewProductDialog(false)}
          loading={loading}
        />
      </ErrorBoundary>
    )}
  </>
}

export default Products;
